import WidgetReservationListResourcePagingResultModel from '../../generated/types/model/resource/WidgetReservationListResourcePagingResultModel';

export default class WidgetReservationListResourcePagingResultViewModel extends WidgetReservationListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
